<template>
  <div class="dialog-container dialog-light importSetup">
    <div class="dialog dialog-md">
      <!-- header import -->
      <ax-dialog-header
        v-if="optionsScreenVisible"
        text="Data import"
        :type="'data-import'"
        :description="'Select an import type to get started'"
      ></ax-dialog-header>
      <ax-dialog-header
        v-if="importExcelVisible"
        text="Import with Excel"
        :type="'import-excel'"
        :description="'Upload your data using our template below'"
      ></ax-dialog-header>
      <!-- select import step -->
      <div class="dialog-body">
        <!-- select import options screen -->
        <div class="import-group" v-if="optionsScreenVisible">
          <div>
            <div class="bubble white mb-2" id="importExcelOption" @click="importWithExcel" value="importExcelOption" tabindex="-1" aria-disabled="true">
              <div class="inner">
                <div class="image">
                  <icon :type="'excel'" />
                </div>
                <div class="description">
                  <h2 class="m-0">Import with Excel</h2>
                  <p class="m-0">Import using our template</p>
                </div>
                <div class="icon">
                  <i class="icon-check"></i>
                </div>
              </div>
            </div>
            <div class="bubble white" id="skipDataImport" @click="skipDataImport" value="skipDataImport" tabindex="-1" aria-disabled="true">
              <div class="inner">
                <div class="image">
                  <img src="../../assets/images/skip-icon.png" width="45">
                </div>
                <div class="description">
                  <h2 class="m-0">Skip import</h2>
                  <p class="m-0"> Use Sinchii software </p>
                </div>
                <div class="icon">
                  <i class="icon-check"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5">
            <k-button
              variant="secondary"
              class="btn btn-lg btn-secondary w-100 mb-2"
              @click="importData"
            >
              Next
            </k-button>
            <k-button
              ref="backBttOfImportExcel"
              class="btn btn-lg btn-outline-primary w-100"
              @click="onBack"
            >
              Back
            </k-button>
          </div>
        </div>
        <!-- import excel -->
        <div class="import-group" v-if="importExcelVisible">
          <div>
            <input
              id="excelTemplateFile"
              type="file"
              class="d-none"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              @change="fileValidation()"
            />
            <select-item
              class="mb-2"
              :text="'Download template'"
              :description="'Fill this with your data'"
              :canSelect=true
              :hideIcon=false
              :type="'download-excel'"
              :highlightSelect="highlightDownloadExcel"
              @select="downloadExcelTemplate()"
            ></select-item>
            <select-item
              :text="'Upload template'"
              :description="descriptionOfUploadOption != '' ? descriptionOfUploadOption : 'Upload your data to Sinchii'"
              :canSelect=true
              :hideIcon=false
              :type="'upload-excel'"
              :highlightSelect="highlightUploadExcel"
              :showDeleteIconOnDescription="showDeleteIconUploadFile"
              @select="uploadExcelTemplate()"
              @onClickDeleteIconOnDescription="deleteUploadExcelTempFile"
            ></select-item>
          </div>
          <div class="mt-5">
            <k-button
              ref="nextBttOfImportExcel"
              variant="secondary"
              class="btn btn-lg btn-secondary w-100 mb-2"
              @click="onclickNextImportExcel"
            >{{ this.importExcelNextBttText }}</k-button>
            <k-button
              ref="backBttOfImportExcel"
              class="btn btn-lg btn-outline-primary w-100"
              @click="showOptionsScreen"
            >
              Back
            </k-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImportExcelService from "../../services/import-excel-service";
import store from "../../store/index";
import icon from "../../components/Icon.vue";
import { useToast } from "vue-toastification";
const toast = useToast();

export default({
  name: "import-set-up",
  components: {
    icon
  },
  data() {
    return {
      selectOptionForDataImport: "",
      arrayOfImportOption: ["importExcelOption", "skipDataImport"],
      optionsScreenVisible: false,
      importExcelVisible: false,
      importXeroVisible: false,
      highlightDownloadExcel: false,
      highlightUploadExcel: false,
      descriptionOfUploadOption: "",
      importExcelNextBttText: "Next",
      showDeleteIconUploadFile: false,
      maxUploadFileSize: 0
    }
  },
  async mounted() {
    this.showOptionsScreen();
    this.maxUploadFileSize = await ImportExcelService.getMaxUploadFileSize();
  },
  computed: {
    anyInvalidImportSetup: function() {
      return this.selectOptionForDataImport === "";
    }
  },
  watch: {
    selectOptionForDataImport: function () {
      let cloneOption = this.arrayOfImportOption;
      const cloneSelect = this.selectOptionForDataImport;
      if (cloneSelect !== "") {
        cloneOption = cloneOption.filter(function (option) {
          return option !== cloneSelect;
        });
      }
      else {
        cloneOption.forEach(option => {
          document.querySelector(`[value=${option}]`).classList.remove("disabled");
        });
      }
    },
    highlightUploadExcel: function() {
      if (this.highlightUploadExcel === true && this.descriptionOfUploadOption !== "Invalid file type") {
        this.importExcelNextBttText = "Review";
      }
      else {
        this.importExcelNextBttText = "Next";
      }
    }
  },
  methods: {
    importWithExcel() {
      this.manipulateOption("importExcelOption");
    },
    skipDataImport() {
      this.manipulateOption("skipDataImport");
    },
    manipulateOption(id) {
      const option = document.getElementById(id);
      this.arrayOfImportOption.forEach(option => {
        document.querySelector(`[value=${option}]`).classList.remove("selected");
      });
      option.classList.add("selected");
      this.selectOptionForDataImport = option.getAttribute("value").toString();
    },
    importData() {
      if (this.anyInvalidImportSetup) {
        toast.clear();
        toast.error("Must select an import option.");
      }
      else {
        switch(this.selectOptionForDataImport) {
        case "skipDataImport":
          this.skipImportSelected();
          break;
        case "importExcelOption":
          this.showImportExcel();
          break;
        case "connectXeroOption":
          this.xeroRedirect();
          break;
        }
      }
    },
    showOptionsScreen() {
      this.optionsScreenVisible = true;
      this.importExcelVisible = false;
      this.deleteUploadExcelTempFile();
      this.$emit("showDots", true);
    },
    showImportExcel() {
      this.optionsScreenVisible = false;
      this.importExcelVisible = true;
      this.$emit("showDots", false);
    },
    skipImportSelected() {
      this.optionsScreenVisible = false;
      this.importExcelVisible = false;
      this.$emit("showDots", false);
      this.$emit("skipImportSelected");
    },
    showImportExcelReview(data) {
      this.optionsScreenVisible = false;
      this.importExcelVisible = false;
      this.$emit("showDots", false);
      this.$emit("excelImportSelected", data);
    },
    onClickBackBtt() {
      this.showOptionsScreen();
      this.highlightDownloadExcel = false;
      this.highlightUploadExcel = false;
    },
    async downloadExcelTemplate() {
      try {
        await ImportExcelService.getExcelTemplate()
        .then(async (response) => {
          this.fileBytesContent = response.data;
          const sampleArr = this.base64ToArrayBuffer(this.fileBytesContent);
          await this.saveByteArray("Sinchii_Excel_Template.xlsx", sampleArr);
          this.highlightDownloadExcel = true;
        })
      }
      catch {
        this.showAlert();
      }
    },
    uploadExcelTemplate() {
      if (!this.showDeleteIconUploadFile) {
        document.getElementById("excelTemplateFile").click();
      }
    },
    base64ToArrayBuffer(base64) {
      const binaryString = window.atob(base64);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    async saveByteArray(reportName, byte) {
      const blob = new Blob([byte], { type: "application/xlsx" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      const fileName = reportName;
      link.download = fileName;
      link.click();
    },
    async fileValidation() {
      const fileInput = document.getElementById("excelTemplateFile");
      const filePath = fileInput.value;
      const fileInputSize = fileInput.files[0].size;
      const isGoodFileSize = fileInputSize <= Number(this.maxUploadFileSize);
      // Allowing file type
      const allowedExtensions = /(\.csv|\.xlsx|\.xls|\.CSV|\.XLSX|\.XLS)$/i;
      if (!allowedExtensions.exec(filePath) || !isGoodFileSize) {
        fileInput.value = "";
        this.highlightUploadExcel = false;
        if (!allowedExtensions.exec(filePath)) {
          this.descriptionOfUploadOption = "Invalid file type";
        }
        else if (!isGoodFileSize) {
          this.descriptionOfUploadOption = `Must be less than ${Number(this.maxUploadFileSize) / 1024 / 1024} MB`;
        }
      }
      else {
        this.highlightUploadExcel = true;
        const fileNameArray = String(filePath).split("\\");
        const fileName = fileNameArray[fileNameArray.length - 1];
        
        this.descriptionOfUploadOption = fileName.substring(0, Math.min(fileName.length, 20));

        if (this.descriptionOfUploadOption.length > 17) {
          this.descriptionOfUploadOption = this.descriptionOfUploadOption.slice(0, 17) + '...';
        }
      }
      this.showDeleteIconUploadFile = true;
    },
    async onclickNextImportExcel() {
      try {
        const importFile = document.getElementById("excelTemplateFile");
        const file = importFile.files[0];
        if (file) {
          const formData = new FormData();
          formData.append("file", file);
          const response = await ImportExcelService.importExcelTemplate(formData);
          const data = response.data;
          if (data.haveErrorOnImportExcel) {
            this.$emit("showDots", false);
            this.$emit("showUnsuccessfulImportExcel", data.errorList);
          }
          else {
            this.showImportExcelReview(data.excelImportReviewData);
          }
        }
        else {
          throw new Error("No file uploaded, please try again.")
        }
      }
      catch(error) {
        this.showAlert(error);
      }
    },
    showAlert(e) {
      toast.clear();
      toast.error(e.message ? e.message : "Something went wrong! Please try again.");
    },
    deleteUploadExcelTempFile() {
      const file = document.getElementById("excelTemplateFile");
      if (file) {
        document.getElementById("excelTemplateFile").value = "";
        this.descriptionOfUploadOption = "";
        this.showDeleteIconUploadFile = false;
        this.highlightUploadExcel = false;
      }
    },
    onBack() {
      this.$emit("onBack");
    }
  }
})
</script>
